import { AnalyticsEventLocation } from '../entities';
import AnalyticsEvent from './analyticsEvent';

export enum ReleaseModalSelection {
  GENERATE = 'generate',
  LIBRARY = 'library',
  UPLOAD = 'upload',
}

const distributionEvents = {
  newReleaseButtonClicked: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('new_release_button_click'),
  newReleaseModalSelect: (selection: ReleaseModalSelection): AnalyticsEvent =>
    AnalyticsEvent.createEvent('new_release_modal_select', { selection }),
  releaseUploadFileAdded: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('release_upload_file_added'),
  releaseUploadSuccess: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('release_upload_success'),
  releaseUploadError: (message: string): AnalyticsEvent =>
    AnalyticsEvent.createEvent('release_upload_error', { message }),
  releaseButtonClicked: (location: AnalyticsEventLocation): AnalyticsEvent =>
    AnalyticsEvent.createEvent('release_button_clicked', { location }),
  releaseCreated: ({
    hasUserAudio,
  }: {
    hasUserAudio: boolean;
  }): AnalyticsEvent =>
    AnalyticsEvent.createEvent('release_created', {
      has_user_audio: hasUserAudio,
    }),
  createReleaseError: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('create_release_error'),
  releaseSubmitted: ({
    hasUserAudio,
  }: {
    hasUserAudio: boolean;
  }): AnalyticsEvent =>
    AnalyticsEvent.createEvent('release_submitted', {
      has_user_audio: hasUserAudio,
    }),
  submitReleaseError: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('submit_release_error'),
  upsellModalTriggered: (location: AnalyticsEventLocation): AnalyticsEvent =>
    AnalyticsEvent.createEvent('distribution_upsell_modal_triggered', {
      location,
    }),
  displayReleasePlaybackStats: () =>
    AnalyticsEvent.createEvent('view_all_stats_click'),
};

export default distributionEvents;
